export default "__VITE_ASSET__CaEV5Qec__"